import { RocketBeeIllustration } from '@/components/illustrations';
import { lightColorPalette } from '@/theme';
import {
  Button,
  Tooltip,
  TooltipProps,
  styled,
  tooltipClasses,
} from '@mui/material';

export const StyledBookDemoTooltip = styled('div')`
  display: flex;
  position: relative;
`;

export const StyledMessage = styled('div')`
  background-color: ${lightColorPalette.lbPurple_40};
  color: ${lightColorPalette.lbText};
  font-size: 1.0769rem;
  font-weight: 400;
  letter-spacing: 0.0308rem;
  white-space: nowrap;
  justify-content: center;
  align-items: center;
  gap: 0.7692rem;
  padding: 10px 11px 10px 50px;
  display: flex;
`;

export const StyledButton = styled(Button)`
  color: ${lightColorPalette.lbWhite};
  padding: 5px 11px;
  height: 100%;
  border: none;
  background-color: ${lightColorPalette.lbBlue_100};
  text-transform: uppercase;
  border-radius: 0;
  font-size: 1.0769rem;
  white-space: nowrap;
  font-family: Roboto;
  font-size: 1.2308rem;
  font-style: normal;
  font-weight: 500;
  letter-spacing: 0.2px;
  /* This ensures the button is clickable */
  pointer-events: all;

  &:hover {
    background-color: ${lightColorPalette.lbBlue_100};
  }
`;

export const StyledMuiTooltip = styled(
  ({ className, ...props }: TooltipProps) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ),
)(() => ({
  [`& .${tooltipClasses.tooltip}`]: {
    maxWidth: 'unset',
  },
}));

export const StyledRocketBee = styled(RocketBeeIllustration)`
  position: absolute;
  left: -36px;
  bottom: -42px;
`;
